import { Component } from 'react'
import { observer, inject } from 'mobx-react'

import { ActionMenu, Loading } from '../../../components'
import { numberToDollars, withRouterProps } from '../../../utils'
import AccountsSectionCard from './AccountsSectionCard'
import {
  SectionBalance,
  DollarSign,
  SectionRow,
  SectionLabel,
  AccountNameLink,
  SectionSubLabel,
  NameField,
  BalanceField,
} from './DashboardStyle'

const SocialSecurityRow = ({ name, balance, include, onEdit }) => (
  <SectionRow>
    <NameField>
      <SectionLabel>
        <AccountNameLink type='button' onClick={onEdit}>
          {name}
        </AccountNameLink>
      </SectionLabel>
      <SectionSubLabel>{include ? 'Include' : 'Exclude'}</SectionSubLabel>
    </NameField>
    <BalanceField>
      <SectionBalance>
        <DollarSign>$</DollarSign>
        {numberToDollars(include ? balance : 0, true)}
      </SectionBalance>
      <ActionMenu items={[{ label: 'Edit', onClick: onEdit }]} ariaLabel={`Actions for ${name}`} />
    </BalanceField>
  </SectionRow>
)

class DashboardSocialSecurity extends Component {
  state = { loading: true }
  _isMounted = false

  // The card depends on base-case data, while the rows depend on Social Security benefits from a
  // separate request. Wait for both so the rows do not briefly show "Exclude / $0".
  componentDidMount() {
    this._isMounted = true
    const {
      getBaseCase,
      getSSBenefits,
      primarySSIBenefits,
      spouseSSIBenefits,
      includeSpouseInPlanning,
    } = this.props.store

    // Require spouse benefits when spouse planning is on;
    // getSSBenefits does not store them while it is off.
    const hasBenefits = primarySSIBenefits && (!includeSpouseInPlanning || spouseSSIBenefits)

    Promise.all([getBaseCase(), hasBenefits ? null : getSSBenefits()])
      .catch(err => console.error(err))
      .finally(() => {
        if (this._isMounted) {
          this.setState({ loading: false })
        }
      })
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  handleSocialSecurityEdit = () => {
    const { navigate } = this.props
    navigate('/social-security')
  }

  render() {
    if (this.state.loading) {
      return <Loading />
    }

    const { store } = this.props
    const { displayName } = store.person
    const { firstName } = store.spouse
    const { primarySSIBenefits, spouseSSIBenefits } = store
    const { primary, spouse } = store.baseCase || {}

    if (!primary && !spouse) {
      return null
    }

    const showSpouseRow = Boolean(store.includeSpouseInPlanning && spouse)

    return (
      <AccountsSectionCard title='Social Security income (monthly)'>
        {primary && (
          <SocialSecurityRow
            name={displayName}
            balance={primarySSIBenefits?.monthlyAmount ?? null}
            include={primarySSIBenefits?.includeSsi ?? null}
            onEdit={this.handleSocialSecurityEdit}
          />
        )}
        {showSpouseRow && (
          <SocialSecurityRow
            name={firstName}
            balance={spouseSSIBenefits?.monthlyAmount ?? null}
            include={spouseSSIBenefits?.includeSsi ?? null}
            onEdit={this.handleSocialSecurityEdit}
          />
        )}
      </AccountsSectionCard>
    )
  }
}

export default withRouterProps(inject('store')(observer(DashboardSocialSecurity)))
